import { create } from 'zustand';

interface ExpandedRowState {
  key: string | null;
  options: string[];
  setExpandedRowKey: (key: string | null) => void;
  addExpandedRowOption: (option: string) => void;
  removeExpandedRowOption: (option: string) => void;
  resetExpandedRow: () => void;
}

export const useCompetitorPriceStore = create<ExpandedRowState>((set) => ({
  key: null,
  options: [],
  setExpandedRowKey: (key) => set({ key }),
  addExpandedRowOption: (option) =>
    set((state) => ({
      options: state.options.includes(option) ? state.options : [...state.options, option],
    })),
  removeExpandedRowOption: (option) =>
    set((state) => ({
      options: state.options.filter((opt) => opt !== option),
    })),
  resetExpandedRow: () => set({ key: null, options: [] }),
}));
